<template>
  <div
    ref="modalRef"
    data-modal=""
    class="modal-wrapper"
    :class="{ 'is--active': isModalActive }"
    bis_skin_checked="1"
    @click="handleModalClick"
  >
    <div class="modal-container" bis_skin_checked="1">
      <h2 class="form-title-50">Розпочнемо співпрацю?</h2>
      <div class="form-block w-form" bis_skin_checked="1">
        <form
          ref="formRef"
          id="email-form"
          name="email-form"
          data-name="Email Form"
          method="post"
          action="/api/modal-form/"
          data-form=""
          class="form"
          data-wf-page-id="6883e59d1edb3d9f894662a3"
          data-wf-element-id="7cf184a1-fb48-5f6e-3c67-0f16e87e8b68"
          aria-label="Email Form"
          @click="handleFormClick"
          @submit="handleFormSubmit"
        >
          <!-- eslint-disable-next-line vue/no-v-for-template-key -->
          <template v-for="stage in [1, 2, 3]" :key="stage">
            <div
              :data-stage="stage"
              class="form-stage"
              :class="{ 'is--active': stage === 1 }"
              bis_skin_checked="1"
            >
              <h4 class="form-stage-title">{{ questionsByStage[stage].title }}</h4>
              <div class="checkbox-wrapper" bis_skin_checked="1">
                <div
                  v-for="(row, rowIndex) in chunkAnswers(questionsByStage[stage].answers)"
                  :key="`row-${stage}-${rowIndex}`"
                  class="radio-row"
                  bis_skin_checked="1"
                >
                  <label
                    v-for="(answer, answerIndex) in row"
                    :key="`answer-${stage}-${rowIndex}-${answerIndex}`"
                    class="radio-wrapper w-radio"
                  >
                    <input
                      type="radio"
                      :name="`stage_${stage}`"
                      :id="`radio-${stage}-${rowIndex}-${answerIndex}`"
                      :data-name="`stage ${stage}`"
                      required=""
                      class="w-form-formradioinput radio-button w-radio-input"
                      :checked="answerIndex === 0 && rowIndex === 0"
                      :value="answer"
                    >
                    <span
                      class="radio-label w-form-label"
                      :for="`radio-${stage}-${rowIndex}-${answerIndex}`"
                    >{{ answer }}</span>
                  </label>
                </div>
              </div>
              <div class="stage-bottom" bis_skin_checked="1">
                <div class="stage-bottom__deco" bis_skin_checked="1">
                  <div
                    v-for="n in 3"
                    :key="`deco-${stage}-${n}`"
                    class="stage-bottom__deco__item"
                    :class="{ 'is--active': n <= stage }"
                    bis_skin_checked="1"
                  ></div>
                </div>
                <div class="stage-bottom__text" bis_skin_checked="1">
                  <p class="stage-bottom__text__ph">Крок {{ stage }} з 3</p>
                </div>
              </div>
            </div>
          </template>
          <div data-stage="4" class="form-stage" bis_skin_checked="1" style="opacity: 0;">
            <h4 class="form-stage-title">4. Заповніть контактну інформацію</h4>
            <div class="input-wrapper" bis_skin_checked="1">
              <input
                class="form-input w-input"
                maxlength="256"
                name="name"
                data-name="Name"
                placeholder="Введіть ім’я"
                type="text"
                id="name"
                required=""
              >
              <div class="phone-field">
                <select
                  class="phone-country"
                  data-phone-country
                  aria-label="Код країни"
                  @change="updatePhoneSelectState"
                >
                  <option value="UA" data-dial-code="+380" data-flag="🇺🇦" selected>🇺🇦 +380</option>
                  <option value="PL" data-dial-code="+48" data-flag="🇵🇱">🇵🇱 +48</option>
                  <option value="DE" data-dial-code="+49" data-flag="🇩🇪">🇩🇪 +49</option>
                  <option value="FR" data-dial-code="+33" data-flag="🇫🇷">🇫🇷 +33</option>
                  <option value="IT" data-dial-code="+39" data-flag="🇮🇹">🇮🇹 +39</option>
                  <option value="ES" data-dial-code="+34" data-flag="🇪🇸">🇪🇸 +34</option>
                  <option value="NL" data-dial-code="+31" data-flag="🇳🇱">🇳🇱 +31</option>
                  <option value="BE" data-dial-code="+32" data-flag="🇧🇪">🇧🇪 +32</option>
                  <option value="CH" data-dial-code="+41" data-flag="🇨🇭">🇨🇭 +41</option>
                  <option value="AT" data-dial-code="+43" data-flag="🇦🇹">🇦🇹 +43</option>
                  <option value="SE" data-dial-code="+46" data-flag="🇸🇪">🇸🇪 +46</option>
                  <option value="NO" data-dial-code="+47" data-flag="🇳🇴">🇳🇴 +47</option>
                  <option value="DK" data-dial-code="+45" data-flag="🇩🇰">🇩🇰 +45</option>
                  <option value="FI" data-dial-code="+358" data-flag="🇫🇮">🇫🇮 +358</option>
                  <option value="CZ" data-dial-code="+420" data-flag="🇨🇿">🇨🇿 +420</option>
                  <option value="SK" data-dial-code="+421" data-flag="🇸🇰">🇸🇰 +421</option>
                  <option value="RO" data-dial-code="+40" data-flag="🇷🇴">🇷🇴 +40</option>
                  <option value="HU" data-dial-code="+36" data-flag="🇭🇺">🇭🇺 +36</option>
                  <option value="TR" data-dial-code="+90" data-flag="🇹🇷">🇹🇷 +90</option>
                  <option value="AE" data-dial-code="+971" data-flag="🇦🇪">🇦🇪 +971</option>
                  <option value="IL" data-dial-code="+972" data-flag="🇮🇱">🇮🇱 +972</option>
                  <option value="GB" data-dial-code="+44" data-flag="🇬🇧">🇬🇧 +44</option>
                  <option value="US" data-dial-code="+1" data-flag="🇺🇸">🇺🇸 +1</option>
                  <option value="CA" data-dial-code="+1" data-flag="🇨🇦">🇨🇦 +1</option>
                  <option value="AU" data-dial-code="+61" data-flag="🇦🇺">🇦🇺 +61</option>
                </select>
                <input
                  class="form-input w-input phone-input"
                  maxlength="30"
                  name="phone"
                  data-name="Phone"
                  placeholder="050 123 4567"
                  type="tel"
                  id="phone"
                  required=""
                  autocomplete="tel"
                  inputmode="tel"
                  data-phone-input
                  @blur="detectPhoneCountry"
                >
              </div>
            </div>
            <div class="stage-bottom" bis_skin_checked="1">
              <input
                type="submit"
                data-wait="Please wait..."
                class="form-button w-button"
                value="Отримати пропозицію"
              >
            </div>
          </div>
          <div data-stage="5" class="form-stage" bis_skin_checked="1" style="opacity: 0;"></div>
        </form>
        <div class="success-message w-form-done" tabindex="-1" role="region" aria-label="Email Form success" bis_skin_checked="1">
          <div class="sucess-text" bis_skin_checked="1">Дякуємо! Вашу заявку отримано!</div>
        </div>
        <div class="w-form-fail" tabindex="-1" role="region" aria-label="Email Form failure" bis_skin_checked="1">
          <div bis_skin_checked="1">Oops! Something went wrong while submitting the form.</div>
        </div>
      </div>
      <div data-close="" class="icon-close" bis_skin_checked="1">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 21 21" fill="none" class="icon-19">
          <path d="M19.9985 20L1 1M20 1L1.0015 20" stroke="white" stroke-width="2" stroke-linecap="round"></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from "vue";

const defaultByStage = {
  1: {
    stage: 1,
    title: "1. Який напрямок вас цікавить?",
    answers: ["Сайт", "ШІ-чат бот", "Застосунок", "Інше"],
  },
  2: {
    stage: 2,
    title: "2. Яка ваша основна мета?",
    answers: ["Збільшити продажі", "Покращити взаємодію з клієнтами", "Заощадити час і ресурси", "Інше"],
  },
  3: {
    stage: 3,
    title: "3. Коли ви хочете розпочати впровадження?",
    answers: ["Негайно", "Протягом місяця", "Хочу дізнатись деталі"],
  },
};

const questions = ref(Object.values(defaultByStage));
const questionsLoaded = ref(false);
const questionsLoading = ref(false);
const modalRef = ref(null);
const formRef = ref(null);
const isModalActive = ref(false);
const currentFormStage = ref(1);

const questionsByStage = computed(() => {
  const map = { ...defaultByStage };
  for (const question of questions.value || []) {
    const stage = Number(question.stage);
    if (!stage || !map[stage]) {
      continue;
    }
    const answers = (question.answers || [])
      .map((answer) => (typeof answer === "string" ? answer : answer?.text))
      .filter(Boolean);
    map[stage] = {
      stage,
      title: question.title || map[stage].title,
      answers: answers.length ? answers : map[stage].answers,
    };
  }
  return map;
});

const chunkAnswers = (answers, size = 2) => {
  const rows = [];
  for (let i = 0; i < answers.length; i += size) {
    rows.push(answers.slice(i, i + size));
  }
  return rows;
};

const getFormMessages = () => {
  const formBlock = formRef.value?.closest(".form-block");
  return {
    successEl: formBlock ? formBlock.querySelector(".w-form-done") : null,
    failEl: formBlock ? formBlock.querySelector(".w-form-fail") : null,
  };
};

const hideFormMessages = () => {
  const { successEl, failEl } = getFormMessages();
  if (successEl) successEl.style.display = "none";
  if (failEl) failEl.style.display = "none";
};

const lockBody = () => {
  document.documentElement.classList.add("is--locked");
  document.body.classList.add("is--locked");
  document.body.style.paddingRight = "";
};

const unlockBody = () => {
  document.documentElement.classList.remove("is--locked");
  document.body.classList.remove("is--locked");
  document.body.style.paddingRight = "";
};

const updatePhoneSelectState = () => {
  const phoneCountry = formRef.value?.querySelector("[data-phone-country]");
  if (!phoneCountry) return;

  const option = phoneCountry.options[phoneCountry.selectedIndex];
  const dialCode = option ? option.getAttribute("data-dial-code") : "";
  const flag = option ? option.getAttribute("data-flag") : "";

  if (dialCode) {
    phoneCountry.setAttribute("data-selected-dial", dialCode);
  }
  if (flag) {
    phoneCountry.setAttribute("data-selected-flag", flag);
  }
};

const detectPhoneCountry = () => {
  const phoneInput = formRef.value?.querySelector("[data-phone-input]");
  const phoneCountry = formRef.value?.querySelector("[data-phone-country]");
  if (!phoneInput || !phoneCountry) return;

  const rawValue = phoneInput.value.trim();
  if (!rawValue.startsWith("+")) return;

  const normalized = rawValue.replace(/[^\d+]/g, "");
  let bestMatch = null;
  let bestLength = 0;

  Array.from(phoneCountry.options).forEach((option) => {
    const dialCode = option.getAttribute("data-dial-code") || "";
    if (!dialCode) return;
    if (normalized.startsWith(dialCode) && dialCode.length > bestLength) {
      bestMatch = option;
      bestLength = dialCode.length;
    }
  });

  if (bestMatch) {
    phoneCountry.value = bestMatch.value;
    updatePhoneSelectState();
    phoneInput.value = normalized.slice(bestLength).trim();
  }
};

const resetForm = () => {
  if (!formRef.value) return;

  formRef.value.reset();
  currentFormStage.value = 1;
  hideFormMessages();
  updatePhoneSelectState();

  const allStages = formRef.value.querySelectorAll("[data-stage]");
  allStages.forEach((stage, index) => {
    stage.style.opacity = index === 0 ? "1" : "0";
    stage.classList.toggle("is--active", index === 0);
  });
};

const openModal = async () => {
  await loadQuestions();
  isModalActive.value = true;
  lockBody();
  await nextTick();
  resetForm();
};

const closeModal = () => {
  isModalActive.value = false;
  unlockBody();
  resetForm();
};

const handleOpenFormClick = (event) => {
  if (!(event.target instanceof Element)) return;

  const trigger = event.target.closest("[data-openform]");
  if (!trigger) return;

  event.preventDefault();
  openModal();
};

const handleModalClick = (event) => {
  if (!(event.target instanceof Element)) return;

  if (event.target.closest("[data-close]") || event.target === modalRef.value) {
    closeModal();
  }
};

const handleEscape = (event) => {
  if (event.key === "Escape" && isModalActive.value) {
    closeModal();
  }
};

const handleFormClick = (event) => {
  if (!(event.target instanceof Element)) return;

  const label = event.target.closest("label.radio-wrapper");
  if (!label || !formRef.value) return;

  const input = label.querySelector('input[type="radio"]');
  if (!input) return;

  const match = input.name.match(/stage[-_](\d+)/);
  if (!match) return;

  const currentStageNum = parseInt(match[1]);
  const nextStageNum = currentStageNum + 1;
  const currentStageEl = formRef.value.querySelector(`[data-stage="${currentStageNum}"]`);
  const nextStageEl = formRef.value.querySelector(`[data-stage="${nextStageNum}"]`);
  if (!currentStageEl || !nextStageEl) return;

  input.value = label.textContent.trim();
  input.checked = true;
  currentFormStage.value = nextStageNum;

  currentStageEl.style.opacity = "0";
  setTimeout(() => {
    currentStageEl.classList.remove("is--active");
    nextStageEl.classList.add("is--active");
    nextStageEl.style.opacity = "0";
    requestAnimationFrame(() => {
      nextStageEl.style.opacity = "1";
    });
  }, 300);
};

const handleFormSubmit = async (event) => {
  event.preventDefault();

  if (!formRef.value) return;

  const { successEl, failEl } = getFormMessages();
  const submitBtn = formRef.value.querySelector('input[type="submit"]');

  if (successEl) successEl.style.display = "none";
  if (failEl) failEl.style.display = "none";
  if (submitBtn) submitBtn.disabled = true;

  const formData = new FormData(formRef.value);
  ["stage_1", "stage_2", "stage_3"].forEach((fieldName) => {
    const checkedInput = formRef.value.querySelector(`input[name="${fieldName}"]:checked`);
    if (!checkedInput) return;
    const label = checkedInput.closest("label");
    const labelText = label ? label.textContent.trim() : checkedInput.value;
    formData.set(fieldName, labelText);
  });

  const phoneInput = formRef.value.querySelector("[data-phone-input]");
  const phoneCountry = formRef.value.querySelector("[data-phone-country]");
  if (phoneInput) {
    let phoneValue = phoneInput.value.trim();
    if (phoneCountry) {
      const option = phoneCountry.options[phoneCountry.selectedIndex];
      const dialCode = option ? option.getAttribute("data-dial-code") : "";
      if (dialCode && phoneValue && !phoneValue.startsWith("+")) {
        phoneValue = `${dialCode} ${phoneValue}`.trim();
      }
    }
    if (phoneValue) {
      formData.set("phone", phoneValue);
    }
  }

  try {
    const response = await fetch(formRef.value.getAttribute("action") || "/api/modal-form/", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      body: new URLSearchParams(formData),
    });

    const payload = await response.json().catch(() => ({}));
    if (!response.ok || !payload.ok) {
      throw new Error("Form submit failed");
    }

    if (successEl) successEl.style.display = "block";
    const allStages = formRef.value.querySelectorAll("[data-stage]");
    const successStage = formRef.value.querySelector('[data-stage="5"]');
    if (successStage) {
      allStages.forEach((stage) => {
        stage.classList.remove("is--active");
        stage.style.opacity = "0";
      });
      successStage.classList.add("is--active");
      successStage.style.opacity = "1";
    }
  } catch (error) {
    if (failEl) failEl.style.display = "block";
  } finally {
    if (submitBtn) submitBtn.disabled = false;
  }
};

const loadQuestions = async () => {
  if (questionsLoaded.value || questionsLoading.value) return;

  questionsLoading.value = true;
  try {
    const response = await fetch("/api/modal-questions/");
    if (!response.ok) {
      return;
    }
    const data = await response.json();
    if (Array.isArray(data?.questions) && data.questions.length) {
      questions.value = data.questions;
      questionsLoaded.value = true;
    }
  } catch (error) {
    console.error("Failed to load modal questions", error);
  } finally {
    questionsLoading.value = false;
  }
};

onMounted(() => {
  updatePhoneSelectState();
  document.addEventListener("click", handleOpenFormClick);
  window.addEventListener("keydown", handleEscape);
  window.addEventListener("contact-modal:open", openModal);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleOpenFormClick);
  window.removeEventListener("keydown", handleEscape);
  window.removeEventListener("contact-modal:open", openModal);
  unlockBody();
});
</script>

<style lang="scss">
@use '@/assets/scss/components/contact-modal';
</style>
